export default __webpack_public_path__ + "static/media/Coffee-Gable-Coffee-Discovery-1.58a83a55.jpg";